// extracted by mini-css-extract-plugin
module.exports = {"content":"Modal_content__zaFNt","header":"Modal_header__3YmfI","close":"Modal_close__5lrkO"};